export default "<div *ngIf=\"showImg\" class=\"backgroundStyle\" [style.background]=\"styleBackground\"></div>";